module.exports = __webpack_public_path__ + "img/out8.5f81c533.jpg";